module.exports = __webpack_public_path__ + "assets/img/page-header.9c3b7dc1.webp";